import { Http } from 'sparnord-utils'

export default class Config extends Http.AbstractModel {
  static get _id () {
    return '29564426-cf83-4376-807d-64b57f89c8ab?depth=3'
  }

  static get endpoint () {
    return `/${Config._id}`
  }

  static async get () {
    let instance = await this.find(Config._id)
    return instance
  }

  get contactTitle () {
    return this.item.properties.contactTitle
  }

  get contactText () {
    return this.item.properties.contactText
  }

  get contactSucces () {
    return this.item.properties.contactSucces
  }

  get contactImage () {
    let image = this.item.properties.contactImage
    return image instanceof Array || !image ? null : Http.Api.root + image.url
  }
}



// WEBPACK FOOTER //
// ./src/models/config.js